import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderRowOfferRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("workorderrowoffer");
